import type { TOC } from '@ember/component/template-only';
import perform from 'ember-concurrency/helpers/perform';
import type { ListLoader } from 'garaje/components/visitors/questionnaires/list/loader';
import runWhenVisible from 'garaje/modifiers/run-when-visible';

interface LoadMoreSignature {
  Args: {
    loader: ListLoader;
  };
}

export default <template>
  {{#if @loader.isRunning}}
    <div class="flex items-center" data-test-load-more>
      <img alt="loading" src="/assets/images/loading-grey.gif" />
      <span class="loading-text pl-2 text-carbon-50">Loading…</span>
    </div>
  {{else if @loader.hasMoreResults}}
    <div data-test-load-more {{runWhenVisible (perform @loader.loadNextPage)}}></div>
  {{/if}}
</template> satisfies TOC<LoadMoreSignature>;
